import AdminModule from './AdminModule';

export default AdminModule;
